//extracted by mini-css-extract-plugin
export default {"rootContainer":"styles_rootContainer__YtgmG","deleteContainer":"styles_deleteContainer__HKOyb","buttonContainer":"styles_buttonContainer__nw2Ne","backBtn":"styles_backBtn__Xhfeg"};;